import { isECatalogue } from './helpers';

const init = async (): Promise<void> => {
  const isBasket = window.location.pathname.includes('basket');
  if (isBasket) {
    return;
  }

  const ROOT_ELEMENT_ID = 'basket-bubble-root';
  const rootElement = document.getElementById(ROOT_ELEMENT_ID);

  if (!rootElement) {
    throw new Error(`Element #${ROOT_ELEMENT_ID} was not found!`);
  }

  const appRender = await import('./AppRender');
  appRender.render(rootElement, isECatalogue());
};

init().catch((error) => {
  throw error;
});

export {}; // needed so the TS treats this file as a module
